import React from 'react';
import { motion, useTransform, useSpring } from 'framer-motion';
import { Gauge, Palette, Volume2, VolumeX } from 'lucide-react';

const StealthControlsImpl = ({ mood, accent, cycleMood, cycleAccent, isMuted, setIsMuted, scrollVelocity, playClick }) => {
  const opacityVal = useTransform(scrollVelocity, [0, 500], [0.6, 0.2]);
  const opacity = useSpring(opacityVal, { damping: 20 });
  return (
    <div className="fixed right-4 top-1/2 -translate-y-1/2 flex flex-col gap-6 z-50">
      {['mood', 'accent', 'sound'].map((ctrl, i) => {
        const label =
          ctrl === 'mood' ? `Cycle mood (currently ${mood.name})` :
          ctrl === 'accent' ? `Cycle accent color (currently ${accent.name})` :
          isMuted ? 'Unmute sound' : 'Mute sound';
        return (
        <motion.button 
          key={ctrl}
          type="button"
          aria-label={label}
          title={label}
          onClick={() => {
            playClick(0.8);
            if(ctrl === 'mood') cycleMood();
            if(ctrl === 'accent') cycleAccent();
            if(ctrl === 'sound') setIsMuted(!isMuted);
          }}
          style={{ opacity }}
          whileHover={{ opacity: 1, scale: 1.1, rotate: ctrl === 'mood' ? 45 : 0 }}
          className="w-14 h-14 p-1.5 rounded-full flex items-center justify-center border border-white/5 border-t-white/15 bg-black/40 backdrop-blur-xl shadow-xl cursor-pointer group relative overflow-hidden focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          <div className="absolute inset-0 bg-[linear-gradient(115deg,transparent_40%,rgba(255,255,255,0.02)_45%,rgba(255,255,255,0.02)_50%,transparent_55%)]" />
          <div className="relative z-10">
            {ctrl === 'mood' && <Gauge size={22} className="text-white/60 group-hover:text-white transition-colors" />}
            {ctrl === 'accent' && <Palette size={22} style={{ color: accent.color }} className="transition-colors" />}
            {ctrl === 'sound' && (isMuted ? <VolumeX size={22} className="text-white/20 group-hover:text-white/40" /> : <Volume2 size={22} className="text-white/60 group-hover:text-white" />)}
          </div>
        </motion.button>
        );
      })}
    </div>
  );
};

export const StealthControls = React.memo(StealthControlsImpl);
